/**
 * Messages shown during plan generation.
 * Generic steps plus one message per selected garden component.
 */

/** Generic steps shown for every plan */
export const GENERIC_STEP_MESSAGES: string[] = [
	'Analysing your space…',
	'Mapping your garden…',
	'Designing the layout…',
	'Choosing the best spots…',
];

/** One or more messages per component – we pick/cycle during generation */
export const COMPONENT_STEP_MESSAGES: Record<string, string[]> = {
	'pool': ['Digging the pool…', 'Tiling the pool…', 'Planning the pool area…'],
	'water-feature': ['Planning the water feature…', 'Placing fountain and pond…'],
	'hot-tub': ['Planning the hot tub area…'],
	'vegetable-garden': ['Laying out the vegetable garden…', 'Planning raised beds…'],
	'flower-beds': ['Planning flower beds and borders…', 'Choosing planting zones…'],
	'greenhouse': ['Siting the greenhouse…', 'Planning the cold frame…'],
	'shed': ['Placing the garden shed…', 'Planning storage…'],
	'pergola': ['Designing the pergola…', 'Planning the gazebo…'],
	'deck': ['Designing the deck…', 'Planning the patio…'],
	'pathway': ['Making the pathway…', 'Laying the walkway…'],
	'driveway': ['Planning the driveway…', 'Laying out parking…'],
	'retaining-wall': ['Planning the retaining wall…'],
	'bbq': ['Setting up the BBQ area…', 'Choosing the grill spot…'],
	'outdoor-kitchen': ['Designing the outdoor kitchen…'],
	'fire-pit': ['Placing the fire pit…', 'Planning the fireplace…'],
	'pizza-oven': ['Planning the pizza oven…'],
	'lounge': ['Choosing the furniture…', 'Planning the seating area…'],
	'playground': ['Planning the play area…'],
	'lighting': ['Planning outdoor lighting…', 'Placing lights…'],
	'fence': ['Planning the fence…', 'Choosing fence lines…'],
	'compost': ['Placing the compost area…'],
};

/**
 * Build the list of messages to cycle through during generation:
 * generic steps first, then one message per selected component.
 */
export function buildGenerationMessages(selectedComponents?: string[]): string[] {
	const messages = [...GENERIC_STEP_MESSAGES];
	if (selectedComponents?.length) {
		selectedComponents.forEach((id) => {
			const componentMessages = COMPONENT_STEP_MESSAGES[id];
			if (componentMessages?.length) {
				// Use first message per component so we don't repeat too much
				messages.push(componentMessages[0]);
			}
		});
	}
	return messages;
}
